<template>
    <div>
        <insurance-clause :content='content'/>
    </div>
</template>

<script>
    import InsuranceClause from '@/components/clause'
    import { FAMILY_PROPERTY } from '@/clause/insurance/lessor/property'
    import { LESSOR_RESPONSIBILITY } from '@/clause/insurance/lessor/responsibility'
    import { PROPERTY_ROBBERY } from '@/clause/insurance/lessor/robbery'
    import { PLUMBING_PIPES } from '@/clause/insurance/lessor/plumbing'
    import { LOCKING_DISTRUCTION } from '@/clause/insurance/lessor/lock'
    import { REPUTATION } from '@/clause/insurance/lessor/reputation'
    import { ADDITION_PROPERTY } from '@/clause/insurance/lessor/addition'
    import { THIRD_REPONSIBILITY } from '@/clause/insurance/lessee/third'
    import { LESSEE_RESPONSIBILITY } from '@/clause/insurance/lessee/responsibility'
    import { LESSEE_LOSS } from '@/clause/insurance/lessee/loss'
    import { JOB_LOSS } from '@/clause/insurance/lessee/job'
    import { LESSEE_DISEASE } from '@/clause/insurance/lessee/disease'
    import { LESSEE_COMMON } from '@/clause/insurance/lessee/common'

    export default {
        components: {
            InsuranceClause
        },
        data () {
            return {
                content: {},
                clauses: {
                    familyproperty: FAMILY_PROPERTY,
                    lessorresponsibility: LESSOR_RESPONSIBILITY,
                    robbery: PROPERTY_ROBBERY,
                    plumbing: PLUMBING_PIPES,
                    lock: LOCKING_DISTRUCTION,
                    reputation: REPUTATION,
                    addition: ADDITION_PROPERTY,
                    third: THIRD_REPONSIBILITY,
                    lesseeresponsibility: LESSEE_RESPONSIBILITY,
                    loss: LESSEE_LOSS,
                    job: JOB_LOSS,
                    disease: LESSEE_DISEASE,
                    common: LESSEE_COMMON
                }
            }
        },
        created () {
            this.content = this.clauses[this.$route.params.name]
        }
    }
</script>
